export const processSections = ({ data }) => {
  if (!Array.isArray(data)) return [];

  const validSections = data.filter(Boolean);

  const uniqueSections = Array.from(
    new Map(validSections.map((item) => [item.id, item])).values()
  );

  return uniqueSections;
};
